import React, { useEffect, useState } from "react";
import { Table } from "antd";


const BasicTable = ({ columns,rows, page, setPage, setCount, setPageSize, count, pageSize, sortHandler, setRows }) => {

  const [tableParams, setTableParams] = useState({
    pagination: {
      current: page,
      pageSize: pageSize,
      total: count,
    },
  });
  useEffect(() => {
    setTableParams({
      ...tableParams,
      pagination: {
        current: page,
        pageSize: pageSize,
        total: count,
      },
    });
  }, [count, page, pageSize, tableParams]);
  const handleTableChange = (pagination, filters, sorter) => {
    setRows([]);
    setPage(pagination?.current || 1);
    setPageSize(pageSize?.pageSize || 10);
    setTableParams({
      pagination,
      filters,
      ...sorter,
    });

    sortHandler(sorter);

    if (pagination.pageSize !== tableParams.pagination?.pageSize) {
    }
  };
  return (
    <div style={{}}>
      <Table
        columns={columns}
        dataSource={rows}
        pagination={tableParams.pagination}
        onChange={handleTableChange}
        scroll={{
          x: 1500,
          y: 600,
        }}
      />
    </div>
  );
};
export default BasicTable;
